import http from "../../utils/http";
import * as TYPES from './action-types';
import dayJs from 'dayjs';
import {Looping, marsToBaidu, numberTime} from "../../utils";
import {ls} from '../../store/local-store';
import channelMgr from "../../service/channel.js";
import { AREA_MODE } from '../../const/area'
import { handleHubOrder } from './handle-hub-order.js'
import * as Sentry from '@sentry/vue';

// 订单状态码
// 待支付
export const ORDER_STATUS_CODES_NOT_PAY = [1];
// 派车中
export const ORDER_STATUS_CODES_DISPATCHING = [2, 3];
// 未上车
export const ORDER_STATUS_CODES_NOT_GET_ON = [4];
// 进行中
export const ORDER_STATUS_CODES_RUNNING = [5];
// 已完成
export const ORDER_STATUS_CODES_DONE = [6, 8, 9];
// 已结束
export const ORDER_STATUS_CODES_CLOSED = [7, 10];
// 退款中
export const ORDER_STATUS_CODES_REFUNDING = [11];
// 已取消
export const ORDER_STATUS_CODES_CANCELED = [12];
// 退款失败
export const ORDER_STATUS_CODES_REFUND_FAILED = [13];
// （系统）退款中
export const ORDER_STATUS_CODES_SYS_REFUNDING = [14, 15];


/**
 * 订单状态
 * @type {array}
 */
const ORDER_STATUS_TEXT = ['',"待付款","派车中","派车中","未上车","进行中","已完成","已结束","已完成","已完成","已结束","退款中","已取消","退款失败","退款中","退款中"];

/**
 * 订单颜色
 * @type {array}
 */
const ORDER_STATUS_COLOR = ['', "#FE5959","#006EFA","#006EFA","#006EFA","#006EFA","#666666","#666666","#666666","#666666","#666666","#FE5959","#666666","#FE5959","#FE5959","#FE5959"];

/**
 * 订单轮询间隔
 * @type {number}
 */
const ORDER_LOOPING_TIMEOUT = 5 * 1000;

/**
 * 订单轮询实例
 * @type {object}
 */
let looping;

/**
 * 上一次轮询orderInfo
 */
let oldOrderInfo;

export function OrderService(context) {
	const dispatch = context.$store.dispatch;
	const ORDER__SET_AIM_ACTION = `order/${TYPES.ORDER__SET_AIM}`;
	const ORDER__SET_ORDER_INFO_ACTION = `order/${TYPES.ORDER__SET_ORDER_INFO}`;
	function _turnTo(name, params = {}, query = {}) {
		context.$router.push({
			name,
			params,
			query
		});
	}
	function turnToOrderPay(params, query) {
		setOrderAim('pay');
		_turnTo('Order', params, query);
	}
	function turnToOrderRunning(params, query) {
		_turnTo('OrderRunning', params, query);
	}

	function redirectToOrderRunning(params, query) {
    _redirectTo('OrderRunning', params, query)
  }

	function _redirectTo(name, params, query) {
		context.$router.replace({
			name,
			params,
			query
		});
	}
	function _setMapDataBusPos(pos) {
		context.$MapService.setMapDataBusPos(pos);
	}
	function _setMapDataRunningOnStop(pos) {
		context.$MapService.setMapDataRunningOnStop(pos);
	}
	function _setMapDataRunningOffStop(pos) {
		context.$MapService.setMapDataRunningOffStop(pos);
	}
	function _getCityId() {
		return context.$store.state.app.cityId;
	}
	function _getUser() {
		return context.$store.state.user.user;
	}
	function _getUserId() {
		let {id} = _getUser() || {};
		return id;
	}
	function _getTicketInfoId() {
		return context.$store.state.app.ticketInfoId;
	}
	function setOrderAim(aim) {
		ls.setItem('aim', aim);
		dispatch(ORDER__SET_AIM_ACTION, aim);
	}
	function getOrderAim() {
		return context.$store.state.order.aim || ls.getItem('aim');
	}
	function _getOrderInfo() {
		return context.$store.state.order.orderInfo;
	}
	function _inArray(item, arr) {
		return Array.from(arr).indexOf(item) !== -1;
	}
	/**
	 * 解析订单状态，并为视图提供状态相关的字段
	 * @param status
	 * @return {{status: *}}
	 * @private
	 */
	function _parseOrderStatus(status) {
		return {
			status, // 接口返回的原始状态值
			statusText: ORDER_STATUS_TEXT[status], // 视图显示的状态文案
			statusColor: ORDER_STATUS_COLOR[status], // 视图显示的状态文字颜色
			isBusVisible: _inArray(status, [ // 是否显示车辆
				...ORDER_STATUS_CODES_NOT_GET_ON,
				...ORDER_STATUS_CODES_RUNNING
			]),
			isOnStopVisible: _inArray(status, [ // 是否显示上车站（进行中时不显示上车站marker）
				...ORDER_STATUS_CODES_DISPATCHING,
				...ORDER_STATUS_CODES_NOT_GET_ON
			]),
			isStatusNotPay: _inArray(status, ORDER_STATUS_CODES_NOT_PAY), // 是否是"待支付"状态
			isStatusRunning: _inArray(status, [ //订单是否进入"进行中"页面
				...ORDER_STATUS_CODES_DISPATCHING,
				...ORDER_STATUS_CODES_NOT_GET_ON,
				...ORDER_STATUS_CODES_RUNNING
			]),
			isStatusCancel: _inArray(status, [ // 订单是否已取消(用户手动取消)，进入已取消页面
				...ORDER_STATUS_CODES_CANCELED
			]),
			isStatusRefunding: _inArray(status, [ // 是否是"退款中"状态
				...ORDER_STATUS_CODES_REFUNDING
			]),
			isStatusDone: _inArray(status, [ // 订单是否已完成
				...ORDER_STATUS_CODES_DONE
			]),
			isStatusClosed: _inArray(status, [ // 订单是否已关闭
				...ORDER_STATUS_CODES_CLOSED
			]),
			isStatusRefundFail: _inArray(status, [ // 订单是否退款失败
				...ORDER_STATUS_CODES_REFUND_FAILED
			]),
			isStatusSysRefunding: _inArray(status, [ // 订单是否是系统退款中（派车失败、后台退款）
				...ORDER_STATUS_CODES_SYS_REFUNDING
			]),
			uiPriceLabel: _inArray(status, [ // 根据是否是退款相关状态，调整金额标签文案
				...ORDER_STATUS_CODES_REFUNDING,
				...ORDER_STATUS_CODES_REFUND_FAILED,
				...ORDER_STATUS_CODES_SYS_REFUNDING
			]) ? '退款金额' : '订单金额',
      isWait: _inArray(status, [...ORDER_STATUS_CODES_NOT_GET_ON]),
      isPendding: _inArray(status, [...ORDER_STATUS_CODES_RUNNING]),
		};
	}

	/**
	 * 解析订单时间，并为视图提供时间相关的字段
	 * @param order
	 * @return {{date: string, createTime, time: string}}
	 * @private
	 */
	function _parseOrderTime(order) {
		let {createTime} = order || {};
		return {
			date: dayJs(createTime).format('YYYY年MM月DD日'),
			time: dayJs(createTime).format('HH:mm'),
		};
	}

  function _parseOrder(order) {
		let {groupPrice} = order || {};
		return {
			isGroupOrder: typeof groupPrice === 'number' && groupPrice > 0
		};
	}

	/**
	 * 获取正在进行中的订单ticketInfoId
	 * @return {*}
	 */
	function fetchRunningOrder() {
		return http.get(`/myTicket/unfinishedTicketV2?cityId=${_getCityId()}&userId=${_getUserId()}`);
	}

	/**
	 * 根据订单状态自动分发路由
	 * @param orderInfo
	 */
	function stateRoute(orderInfo) {
		let {status} = orderInfo || {};
		let {
			isStatusNotPay,
			isStatusRunning,
			isStatusCancel,
			isStatusRefunding,
			isStatusDone,
			isStatusClosed,
			isStatusRefundFail,
			isStatusSysRefunding
		} = _parseOrderStatus(status) || {};
		let routeName = context.$route.name;
		console.log('[$OrderService] stateRoute: 当前页面: ', routeName);
		if (isStatusNotPay) {
			if (getOrderAim() !== 'state') {
				setOrderAim('pay');
			}
			// 跳转到支付页面
			if (routeName !== 'Order') {
				turnToOrderPay();
			}
			return;
		}
		if (isStatusRunning && routeName !== 'OrderRunning') {
			// 跳转到运行中页面
			console.log('[autoRoute]跳转到运行中页面', _getTicketInfoId());
			_redirectTo('OrderRunning', {}, {
				ticketInfoId: _getTicketInfoId()
			});
			return;
		}

		if (isStatusCancel) {
			// 跳转到已取消页面
			setOrderAim('info');
			if (routeName !== 'Order') {
				_redirectTo('Order', {}, {
          ticketInfoId: _getTicketInfoId()
        });
			}
			return;
		}
		if (isStatusRefunding) {
			// 跳转到退票中页面
			setOrderAim('info');
			if (routeName !== 'Order') {
				_redirectTo('Order', {}, {
          ticketInfoId: _getTicketInfoId()
        });
			}
			return;
		}
		if (isStatusDone) {
			// 跳转到已完成页面
			setOrderAim('info');
			if (routeName !== 'Order') {
				_redirectTo('Order', {}, {
          ticketInfoId: _getTicketInfoId()
        });
			}
			return;
		}
		if (isStatusClosed) {
			// 跳转到已关闭页面
			setOrderAim('info');
			if (routeName !== 'Order') {
				_redirectTo('Order', {}, {
          ticketInfoId: _getTicketInfoId()
        });
			}
			return;
		}
		if (isStatusRefundFail) {
			// 跳转到退款失败页面
			let aim = getOrderAim() === 'info' ? 'info' : 'state';
			setOrderAim(aim);
			if (routeName !== 'Order') {
				_redirectTo('Order', {}, {
          ticketInfoId: _getTicketInfoId()
        });
			}
			return;
		}
		if (isStatusSysRefunding) {
			// 跳转到系统退款页面
			let aim = getOrderAim() === 'info' ? 'info' : 'state';
			setOrderAim(aim);
			if (routeName !== 'Order') {
        setTimeout(() => {
          _redirectTo('Order', {}, {
            ticketInfoId: _getTicketInfoId()
          });
        });
			}
		}
	}

	/**
	 * 获取订单信息
	 * @param {number} [ticketInfoId] - 订单id
	 * @param {boolean} [autoRoute=true] - 是否自动分发路由
	 * @return {Q.Promise<unknown>}
	 */
	function getOrderInfo(ticketInfoId, autoRoute = true, inLoop = false) {
		ticketInfoId = ticketInfoId || _getTicketInfoId();
		if (!ticketInfoId) {
			return Promise.reject('no ticket info id');
		}
		let {id: oldId, status: oldStatus, busLicense: oldLicense, sureStatus: oldSureStatus, sureBus: oldSureBus} = oldOrderInfo || {};
    const linePromotionId = channelMgr.getChannelInfo('linePromotionId')
    const queryStr = linePromotionId ? `&promotionId=${linePromotionId}` : ''
    // sentry记录cityId信息，排查错误
    const cityId = _getCityId();
		Sentry.captureMessage(`请求的cityId: ${cityId}, 页面url: ${window.location.href}, query上的cityId: ${context.$route.query.cityId}, ls的cityId: ${ls.getItem('cityId')}`, 'debug');
		return http.get(`/myTicket/list?ticketInfoId=${ticketInfoId}&cityId=${_getCityId()}&userId=${_getUserId()}${queryStr}`).then((res) => {
			if (inLoop && !looping) {
				console.log('[getOrderInfo] in loop but not looping, skip it.');
				return;
			}
			console.log('获取订单详情', res);
			let {list = []} = res || {};
			let [item = {}] = list || [{}];
			let {status, createTime, busLicense: license} = item || {};
			console.log('bus-----', oldLicense, license, status, oldStatus);
			let orderInfo = Object.assign(
				{},
				item,
        _parseOrder(item),
				_parseOrderStatus(status),
				_parseOrderTime({createTime}),
				{timestamp: new Date().getTime()}
			);
      // 枢纽站模式，单独处理逻辑
      if (orderInfo.mode === AREA_MODE.HUB) {
        const hubOrderInfo = handleHubOrder({
          context,
          order: orderInfo,
          oldOrder: oldOrderInfo
        })
        oldOrderInfo = hubOrderInfo;
        dispatch(ORDER__SET_ORDER_INFO_ACTION, hubOrderInfo);
        context.$MapService.setMapRenderFlag();
        if (autoRoute) {
          stateRoute(hubOrderInfo);
        }
        return hubOrderInfo
      }
			let {busLng, busLat, busLicense, busId, onStopLng, onStopLat, onStopName, onStopId, offStopLng, offStopLat, offStopName, offStopId, route, stopNavList, sureStatus, sureTime, sureBus, onTime } = orderInfo || {};

      const isArrive = sureStatus === 1 && sureTime > 0 // 司机是否到站
      const isTimeoutArrive = sureStatus === 1 && sureTime <= 0 // 司机是否超时到站
      orderInfo.isArrive = isArrive
      orderInfo.isTimeoutArrive = isTimeoutArrive

			if (oldId === ticketInfoId && oldStatus != status) {
				if(_inArray(status, [...ORDER_STATUS_CODES_NOT_GET_ON]) && !_inArray(oldStatus, [...ORDER_STATUS_CODES_RUNNING])) {
					orderInfo.statusChangeText = '派车成功！请耐心等候';
				  let { lng, lat } = marsToBaidu(busLng, busLat)
          context.$MapService.setMapDataBusPos({
            lng,
            lat,
            point: new BMapGL.Point(lng, lat),
            license: busLicense,
            onTime
          })
					context.$MapService.setMapFitViewModeC()
				  context.$MapService.setFitView()
				} else if(_inArray(status, [...ORDER_STATUS_CODES_RUNNING])) {
					orderInfo.statusChangeText = '您已上车！';
				} else {
					orderInfo.statusChangeText = '';
				}
			} else {
				if (oldLicense && license && oldLicense !== license && _inArray(status, [...ORDER_STATUS_CODES_NOT_GET_ON]) && _inArray(oldStatus, [...ORDER_STATUS_CODES_NOT_GET_ON])) {
					orderInfo.statusChangeText = '重新派车成功！请耐心等候';
				}
			}

      if (oldId === ticketInfoId && oldSureStatus !== sureStatus && sureStatus === 1) {
        orderInfo.sureStatusChangeText = '司机已到站，请尽快前往上车站'
      }
      // 展示派车等待时间过长modal
      if (oldId === ticketInfoId && oldSureBus !== sureBus && sureBus === 2) {
        orderInfo.showWaitModal = true
      }

			console.log('===车辆位置:::', busLng, busLat, orderInfo.isBusVisible);
			if (busLng && busLat && orderInfo.isBusVisible) {
				let {lng, lat} = marsToBaidu(busLng, busLat);
				let bus = {
          lng,
          lat,
          point: new BMapGL.Point(lng, lat),
          license: busLicense,
          id: busId,
          isArrive,
          isTimeoutArrive,
          onTime
        }
				_setMapDataBusPos(bus);
			}
			if (onStopLng && onStopLat && orderInfo.isOnStopVisible) {
				let {lng, lat} = marsToBaidu(onStopLng, onStopLat);
				let runningOnStop = {
					lng,
					lat,
					point: new BMapGL.Point(lng, lat),
					name: onStopName,
					id: onStopId
				};
				_setMapDataRunningOnStop(runningOnStop);
			} else {
				_setMapDataRunningOnStop(null);
			}
			if (!orderInfo.isOnStopVisible) {
				context.$MapService.removeOverlayRunningOnStopMarker();
			}
			if (offStopLng && offStopLat) {
				let {lng, lat} = marsToBaidu(offStopLng, offStopLat);
				let runningOffStop = {
					lng,
					lat,
					point: new BMapGL.Point(lng, lat),
					name: offStopName,
					id: offStopId
				};
				_setMapDataRunningOffStop(runningOffStop);
			}
      if (route && orderInfo.isBusVisible) {
        context.$MapService.setMapDataRunningRoute(route)
      } else {
        context.$MapService.setMapDataRunningRoute(null)
      }
      if (stopNavList && stopNavList.length && orderInfo.isBusVisible) {
        const lastItem = stopNavList[stopNavList.length - 1]
        const has = lastItem && lastItem.stopId === offStopId
        const list = [...stopNavList]
        if (!has) {
          list.push({
            stopId: offStopId,
            lng: offStopLng,
            lat: offStopLat,
          })
        }
        context.$MapService.setMapDataRunningNaviStop(list)
      } else {
        context.$MapService.setMapDataRunningNaviStop(null)
      }

			oldOrderInfo = orderInfo;
			dispatch(ORDER__SET_ORDER_INFO_ACTION, orderInfo);
			console.log('解析后订单详情', orderInfo);
			context.$MapService.setMapRenderFlag();
			// 自动分发路由
			if (autoRoute) {
				stateRoute(orderInfo);
			}
			return orderInfo;
		}).catch((res) => {
			console.log('获取订单详情失败', res);
			return res;
		});
	}

	/**
	 * 获取区域退票协议
	 * @param areaId
	 * @return {*}
	 */
	function getRefundRule(areaId) {
		return http.post('/refund/ruleContent', {lineId: areaId});
	}
	return {
    turnToOrdersView: (params, query) => _turnTo('Orders', params, query),
    turnToOrderView: (params, query) => _turnTo('Order', params, query),
    turnToOrderCancelView: (params, query) =>
      _redirectTo('OrderCancel', params, query),
    /**
     * 跳转至订单页，去支付
     * @param params
     */
    turnToOrderPay,
    /**
     * 跳转至订单页，查看支付结果/继续支付
     * @param params
     */
    turnToOrderState: (params, query) => {
      setOrderAim('state')
      _turnTo('Order', params, query)
    },
    /**
     * 跳转至订单页，查看详情
     * @param params
     * @param query
     */
    turnToOrderInfo: (params, query) => {
      setOrderAim('info')
      _turnTo('Order', params, query)
    },
    setOrderAimPay() {
      setOrderAim('pay')
    },
    setOrderAimState() {
      setOrderAim('state')
    },
    setOrderAimInfo() {
      setOrderAim('info')
    },
    getOrderAim,
    /**
     * 跳转至正在运行订单页
     * @param params
     * @param query
     */
    turnToOrderRunning,
    /**
     * 跳转至正在运行订单页 replace
     */
    redirectToOrderRunning,
    /**
     * 跳转至订单取消页面
     * @param params
     */
    turnToOrderCancel(params, query) {
      _redirectTo('OrderCancel', params, query)
    },
    getOrderList: () => {
      const linePromotionId = channelMgr.getChannelInfo('linePromotionId')
      const queryStr = linePromotionId ? `&promotionId=${linePromotionId}` : ''
      return http
        .get(`/myTicket/list?cityId=${_getCityId()}&userId=${_getUserId()}${queryStr}`)
        .then(res => {
          let { list = [] } = res || {}
          return Array.from(list).map(p => {
            const { status } = p
            return {
              ...p,
              ..._parseOrderStatus(status),
              ..._parseOrderTime(p)
            }
          })
        })
        .catch(res => {
          console.log('获取订单列表失败', res)
        })
    },
    /**
     * 获取订单信息
     */
    getOrderInfo,
    /**
     * 获取区域退票协议
     */
    getRefundRule,
    /**
     * 判断订单是否在派车中状态
     * @param {object} [order] - 订单信息，默认是当前进行中订单
     * @return {boolean}
     */
    isOrderDispatching(order) {
      let { status } = order || _getOrderInfo() || {}
      return _inArray(status, [...ORDER_STATUS_CODES_DISPATCHING])
    },
    /**
     * 判断订单是否是已接单未上车状态
     * @param {object} [order] - 订单信息，默认是当前进行中订单
     * @return {boolean}
     */
    isOrderDispatchedAndUserNotGetOn(order) {
      let { status } = order || _getOrderInfo() || {}
      return _inArray(status, [...ORDER_STATUS_CODES_NOT_GET_ON])
    },
    /**
     * 判断订单是否进行中（正在送乘客）
     * @param {object} [order] - 订单信息，默认是当前进行中订单
     * @return {boolean}
     */
    isOrderRunningWithUser(order) {
      let { status } = order || _getOrderInfo() || {}
      return _inArray(status, [...ORDER_STATUS_CODES_RUNNING])
    },
    /**
     * 开始订单信息轮询
     */
    startLooping: () => {
      console.log('开始轮询')
      if (looping) {
        console.log('已有轮询')
        return
      }
      looping = Looping(() => {
        // 轮询获取订单信息，并存入store，供不同页面使用
        getOrderInfo(_getTicketInfoId(), true, true)
      }, ORDER_LOOPING_TIMEOUT)
      looping.start()
    },
    /**
     * 停止订单信息轮询
     */
    stopLooping: () => {
      console.log('结束轮询')
      if (looping) {
        looping.stop()
        looping = null
      }
    },
    /**
     * 获取正在进行中的订单ticketInfoId
     * @return {*}
     */
    fetchRunningOrder,
    /**
     * 恢复正在进行的订单
     */
    recoverRunningOrder() {
      return new Promise((resolve, reject) => {
        let userId = _getUserId()
        if (!userId) {
          reject()
          return
        }
        fetchRunningOrder()
          .then(res => {
            console.log('查询未完成订单', res)
            if (!Array.isArray(res) || !res.length) {
              resolve(null)
              return
            }
            const undefinedNum = res.length
            const undefinedOrders = res

            if (undefinedNum === 1) {
              const [order] = res
              if (order && order.id) {
                context.$AppService.setTicketInfoId(order.id)
              }
            }
            resolve({ undefinedNum, undefinedOrders })
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    /**
     * 发起退款
     * @param ticketInfoId
     * @return {*}
     */
    cancelOrder(ticketInfoId) {
      return http.post('/refund/refundTicket', { ticketInfoId })
    },
    /**
     * 取消前检查取消次数限制
     * @param ticketInfoId
     * @return {*}
     */
    checkCancelOrder(ticketInfoId) {
      return http.get(`/refund/confirm?ticketId=${ticketInfoId}`)
    },
    /**
     * 上报取消行程原因
     * @param ticketInfoId
     * @param refundReason
     * @return {*}
     */
    reportCancelReason(ticketInfoId, refundReason) {
      return http.post('/refund/refundReason', { ticketInfoId, refundReason })
    },
    /**
     * 计算阶梯价格（包含原价）
     * @description 计价规则：两个都是特殊站点,先按普通票比价格,取大的站点逻辑,相同的话取下车点,其次按站点阶梯价格计算，哪个站点阶梯价大，算哪个；其次按站点价格计算，哪个站点价格大，算哪个；都没有配置的话，按原来逻辑计算
     * @params passengerCount number 乘车人数
     * @params onStop object 上车点 
     * @params offStop object 下车点
     * @typedef priceList array[{num: number, price: number(总价)}] 阶梯价格表 num:最低人数, price:单价
     * @return number
     */
    calcStopLadderPrice(passengerCount, onStop, offStop) {
      let {price: onStopPrice, priceList: onStopPriceList, } = onStop || {}
      let { price: offStopPrice, priceList: offStopPriceList } = offStop || {}
      console.log('onStop', onStop)
      console.log('offStop', offStop)

      // 两个都是特殊站点，淘汰便宜的阶梯票价
      if (typeof onStopPrice === 'number' && typeof offStopPrice === 'number') {
        const onMax = (onStopPrice || 0) > (offStopPrice || 0)
        onStopPriceList = onMax ? onStopPriceList : []
        offStopPriceList = onMax ? [] : offStopPriceList
      }
      // 当前处于阶梯价哪个等级
      function getCurLadderIndex(list, passengerCount) {
        let idx = -1
        list.forEach((level, index) => {
          let { num } = level || {}
          if (passengerCount >= num) {
            idx = index
          }
        })
        return idx
      }
      const onLadderIdx = getCurLadderIndex(onStopPriceList, passengerCount)
      const offLadderIdx = getCurLadderIndex(offStopPriceList, passengerCount)

      const curOnLadder = onStopPriceList[onLadderIdx] || {}
      const curOffLadder = offStopPriceList[offLadderIdx] || {}

      const { num: onNum=0, price: onPrice=0 } = curOnLadder || {}
      const { num: offNum=0, price: offPrice=0 } = curOffLadder || {}

      const onStopActualPrice = (passengerCount - onNum) * (onStopPrice || 0) + onPrice
      const offStopActualPrice = (passengerCount - offNum) * (offStopPrice || 0) + offPrice

      if (onLadderIdx > -1 && offLadderIdx > -1) {
        // 现在这种情况不会出现了,先保留,后续如果要横向比较,删掉上面的 "两个都是特殊站点" 判断即可

        if ( onStopActualPrice >= offStopActualPrice ) {
          return {
            actualPrice: onStopActualPrice,
            originPrice: numberTime((onStopPrice || 0), passengerCount)
          }
        } else {
          return {
            actualPrice: offStopActualPrice,
            originPrice: numberTime((offStopPrice || 0), passengerCount)
          }
        }
      } else if (onLadderIdx > -1) {
        return {
          actualPrice: onStopActualPrice,
          originPrice: numberTime((onStopPrice || 0), passengerCount)
        }
      } else if (offLadderIdx > -1) {
        return {
          actualPrice: offStopActualPrice,
          originPrice: numberTime((offStopPrice || 0), passengerCount)
        }
      } else {
        // 至少其中一个是特殊站点，并且阶梯票价没有匹配上
        if (
          typeof onStopPrice === 'number' ||
          typeof offStopPrice === 'number'
        ) {
          return {
            actualPrice: Math.max(
              numberTime((onStopPrice || 0), passengerCount),
              numberTime((offStopPrice || 0), passengerCount)
            ),
            originPrice: Math.max(
              numberTime((onStopPrice || 0), passengerCount),
              numberTime((offStopPrice || 0), passengerCount)
            )
          }
        } else {
          return null
        }
      }
    },
    /**
     * 计算阶梯价格（包含原价）
     * @description 计价规则：当购票人数大于等于该档人数，且小于下一档人数时，按照该档金额计算
     * @params originPrice number 原价
     * @params priceList priceList 阶梯价格表
     * @params passengerCount number 乘车人数
     * @typedef priceList array[{num: number, price: number}] 阶梯价格表 num:最低人数, price:总价
     * @return number
     */
    calculateLadderPrice(
      originPrice = 0,
      priceList = [],
      passengerCount = 0,
      onStop,
      offStop
    ) {
      if (onStop && offStop) {
        const stopRes = this.calcStopLadderPrice(
          passengerCount,
          onStop,
          offStop
        )
        if (stopRes) return stopRes
      }
      if (!priceList.length) {
        return {
          actualPrice: numberTime(originPrice, passengerCount),
          originPrice: numberTime(originPrice, passengerCount)
        }
      }
      let [firstLevel = {}] = priceList || []
      let { num = 0 } = firstLevel || {}

      if (num > passengerCount) {
        return {
          actualPrice: numberTime(originPrice, passengerCount),
          originPrice: numberTime(originPrice, passengerCount)
        }
      }
      let arr = [...priceList]
      const currentLevel = arr.reverse().find(item => {
        let { num = 0 } = item || {}
        return passengerCount >= num
      })

      let {price:currentPrice = 0, num:currentNum = 0} = currentLevel || {}
      currentPrice = currentPrice || 0
      currentNum = currentNum || 0

      const actualCurrentPrice = (passengerCount - currentNum) * originPrice + currentPrice

      return {
        actualPrice: actualCurrentPrice,
        originPrice: numberTime(originPrice, passengerCount)
      }
    },
    /**
     * 等待派车过长，status 1: 确认等待  3：取消等待
     * userAction 1: 用户操作  2: 自动确认
     */
    sureWait({ id, status, userAction }) {
      return http.get(
        `/myTicket/sureWait?cityId=${_getCityId()}&userId=${_getUserId()}&id=${id}&status=${status}&userAction=${userAction}`
      )
    }
  }
}

export function install(Vue, context) {
	Vue.prototype.$OrderService = OrderService(context);
}
